var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUgentLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "128.882px",
    height: "98px",
    viewBox: "0 0 128.882 98",
    enableBackground: "new 0 0 128.882 98",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1E64C8",
    d: "M0,88.529c0-7.205,1.853-9.471,6.588-9.471c1.441,0,2.676,0.412,3.294,0.824v2.471 c-0.618-0.412-2.059-0.824-3.088-0.824c-3.088,0-4.118,1.029-4.118,7.206c0,5.971,0.823,7.206,3.5,7.206 c0.823,0,1.441-0.206,2.059-0.206v-6.177H5.353v-2.265h5.353v9.882C10.088,97.588,8.03,98,6.177,98C1.235,98,0,95.324,0,88.529z  M13.588,79.471h8.441v2.265h-5.971v5.559h4.735v2.06h-4.735v6.176h5.971v2.265h-8.441V79.471z M24.912,79.471h2.882l5.765,14.412 c-0.206-1.441-0.412-3.295-0.412-4.941v-9.677h2.471v18.118h-2.882l-5.765-14.618c0.206,1.441,0.412,3.294,0.412,4.941v9.677h-2.47 V79.471z M37.677,79.471h10.5v2.265h-3.912v16.059h-2.676V81.735h-3.912V79.471z M0.412,66.706V53.941h2.676v12.765 c0,2.677,0.824,3.5,2.882,3.5c1.853,0,2.882-0.823,2.882-3.5V53.941h2.677v12.765c0,4.118-1.647,5.765-5.353,5.765 C2.059,72.471,0.412,70.824,0.412,66.706z M14.618,53.941H17.5l5.765,14.412c-0.206-1.441-0.412-3.295-0.412-4.941v-9.677h2.471 v18.323h-2.882l-5.765-14.412c0.206,1.441,0.412,3.295,0.412,4.941v9.471h-2.471V53.941z M29.03,53.941h2.676v18.117H29.03V53.941z  M33.971,53.941h2.676l2.265,9.471c0.412,1.441,0.823,3.912,1.029,5.764c0.206-1.852,0.618-4.322,1.029-5.764l2.265-9.471h2.677 l-4.735,18.117H38.5L33.971,53.941z M48.177,53.941h8.441v2.265h-5.971v5.559h4.941v2.06h-4.735V70h5.971v2.059h-8.441V53.941 H48.177z M59.706,53.941h4.118c3.294,0,5.765,1.234,5.765,5.353c0,2.882-1.441,4.323-3.088,4.941l3.912,7.823H67.53l-3.5-7.412 h-1.647v7.412h-2.676V53.941z M62.177,56.206v6.382h1.441c2.059,0,3.295-0.412,3.295-3.294c0-2.677-1.441-3.088-3.295-3.088H62.177 z M72.471,71.854v-2.471c0.617,0.411,1.853,0.823,3.088,0.823c1.646,0,2.883-0.618,2.883-2.471c0-1.441-0.824-2.265-1.854-3.294 l-1.441-1.235c-1.646-1.441-2.676-2.471-2.676-4.941c0-2.882,1.853-4.735,5.353-4.735c1.235,0,2.471,0.412,2.882,0.617v2.266 c-0.617-0.412-1.646-0.618-2.676-0.618c-1.647,0-2.883,0.618-2.883,2.471c0,1.441,0.824,2.265,1.854,3.294l1.441,1.235 c1.646,1.441,2.676,2.471,2.676,4.941c0,2.882-1.854,4.735-5.354,4.735C74.324,72.471,73.088,72.059,72.471,71.854z M84,53.941 h2.471v18.117h-2.677V53.941H84z M88.942,53.941h10.5v2.265H95.53v15.853h-2.677V56h-3.911V53.941L88.942,53.941z M101.706,53.941 h8.441v2.265h-5.971v5.559h4.941v2.06h-4.735V70h5.971v2.059h-8.44V53.941H101.706z M113.235,53.941h2.678v18.117h-2.678V53.941z  M118.382,53.941h10.5v2.265h-3.911v15.853h-2.677V56h-3.912V53.941z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.559,
    y: 16.676,
    fill: "#1E64C8",
    width: 2.471,
    height: 16.677
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.706,
    y: 16.676,
    fill: "#1E64C8",
    width: 2.471,
    height: 16.677
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.853,
    y: 16.676,
    fill: "#1E64C8",
    width: 2.471,
    height: 16.677
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 16.676,
    fill: "#1E64C8",
    width: 2.471,
    height: 16.677
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.147,
    y: 16.676,
    fill: "#1E64C8",
    width: 2.471,
    height: 16.677
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.294,
    y: 16.676,
    fill: "#1E64C8",
    width: 2.47,
    height: 16.677
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.441,
    y: 16.676,
    fill: "#1E64C8",
    width: 2.471,
    height: 16.677
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.088,
    y: 36.029,
    fill: "#1E64C8",
    width: 38.5,
    height: 2.471
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1E64C8",
    points: "38.912,14 5.559,14 3.088,11.529 41.588,11.529  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.412,
    y: 41.176,
    fill: "#1E64C8",
    width: 43.647,
    height: 2.471
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1E64C8",
    points: "22.235,0 0.412,7.824 0.412,10.294 22.235,2.471 44.059,10.294 44.059,7.824  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUgentLogo);
export default __webpack_public_path__ + "static/media/ugent_logo.9d2a4f7de8df441028ff30533d852edf.svg";
export { ForwardRef as ReactComponent };